var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('el-scrollbar',{staticClass:"sildebar_scroll",class:{isCollapse:_vm.isCollapse}},_vm._l((_vm.asideList),function(item,index){return _c('SidebarItem',{key:index,attrs:{"item":item},on:{"update:item":function($event){item=$event},"onClickItem":_vm.onClickItem}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }